<div *ngIf="value.length">
  {{value}}
</div>
<!--<div *ngIf="value.length === 0">-->
<div class="ai-btn" *ngIf="activeBtn">
  <button [disabled]="pending" (click)="getTitle()" class="bulk-btn" mat-raised-button style="background-color: #f1a85d;"><mat-icon>get_app</mat-icon> Get</button>
</div>
